/**
* Creates a fake setTimeout function
* param {int} time - set time out number
*/
async function tf_sto(time) {
    return new Promise((resolve, reject) => {
        if (isNaN(time)) {
            reject(new Error('is not a number'))
        } else {
            setTimeout(resolve, time)
        }

    });
}

/**
* Breakpoints to use in the DOMTF class
*/
const breakpoints = [
    {
        'mobile': 580,
    },
    {
        'tablets': 810,
    },
    {
        'tabletm': 1024,
    },
    {
        'tabletl': 1300,
    },
    {
        'laptop': 1570
    },
    {
        'desktop': 1700
    }
]


export { tf_sto, breakpoints };

export const HTML = document.documentElement;

/*
  "jQuery like" ready function:
  Usage:

  import ready from 'Utils/global';
  ready(() => init());
*/

export default Document.prototype.ready = (fn) => {
    if (fn && typeof fn === 'function') {
        document.addEventListener('DOMContentLoaded', () => {
            if (document.readyState === 'interactive' || document.readyState === 'complete') {
                return fn();
            }
        });
    }
};